import React from 'react'
import { useTheme } from '@material-ui/core/styles'
import { Link } from 'src/common/razzle-platform-components/router'
import { useIntl } from 'src/common/razzle-platform-translate'
import ReactLoading from 'react-loading'
import './DefaultMarkerPreviewItem.css'
import ImageSlider from './ImageSlider'

let BookmarkOfProduct = null
try {
    BookmarkOfProduct = require('src/common/razzle-platform-bookmarkofproduct/BookmarkOfProduct').BookmarkOfProduct
} catch (error) {
    console.log(error);
}

export function DefaultMarkerPreviewItem(props) {
    const { formatMessage } = useIntl()
    const theme = useTheme()
    const { item, itemRoutes } = props
    
    return (
        <div className="marker-preview">
            {BookmarkOfProduct && (
                <div className="bookmark">
                    <BookmarkOfProduct
                        productId={item.id}
                        bookmarkButton={({ onClick, isBookmarked, inProgress }) =>
                            inProgress ? (
                                <ReactLoading
                                    type={'spokes'}
                                    color={theme.palette.primary.main}
                                    height={25}
                                    width={25}
                                />
                            ) : (
                                <i onClick={onClick} className={`${isBookmarked ? 'fas' : 'far'} fa-heart`}></i>
                            )
                        }
                    />
                </div>
            )}
            <Link target="_blank" to={itemRoutes.details(item)}>
                <a className="no-underline" rel="noopener noreferrer">
                    <div className="img-container">
                        <div>
                            <ImageSlider item={item} />
                        </div>
                    </div>
                    <div className="content-wrap">
                        {item.reviewScore > 0 && <div className="rating">
                            <i className="fas fa-star"></i>
                            <span className="score">{item.reviewScore}</span>
                            <span className="number">({item.reviewsNumber})</span>
                        </div>}
                        <div className="category truncate">{item.category.name}</div>
                        <div className="title truncate">{item.name}</div>
                        <div className="price">
                            <span>{item.price}</span> {formatMessage({ id: 'RP/jour', defaultMessage: 'RP/jour' })}
                        </div>
                    </div>
                </a>
            </Link>
        </div>
    )
}
